export default __webpack_public_path__ + "./fonts/usd.2de01a18.svg";